"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTopicInfoMap = createTopicInfoMap;
exports.createTopicInfoRecord = createTopicInfoRecord;
exports.enrichResultWithMetadata = enrichResultWithMetadata;
exports.extractExcerpt = extractExcerpt;
exports.extractTopicIds = extractTopicIds;
exports.getHitUrl = getHitUrl;
exports.getTopicId = getTopicId;
exports.mergeAnswerFromHit = mergeAnswerFromHit;
exports.mergeHitsWithMetadata = mergeHitsWithMetadata;
exports.stripHtmlTags = stripHtmlTags;
exports.transformHit = transformHit;
exports.transformHits = transformHits;
exports.transformHitsWithMetadata = transformHitsWithMetadata;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Strip HTML tags from content using the shared htmlParser utility
 * Works in both browser and SSR environments
 *
 * @param html - HTML string to strip
 * @returns Plain text without HTML tags
 */
function stripHtmlTags(html) {
  return _htmlParser.default.stripHtml(html) || '';
}
/**
 * Extract a text excerpt from a search hit
 * Prioritizes highlighted content for better search relevance display
 *
 * @param hit - Algolia hit with highlight results
 * @param maxLength - Maximum length of excerpt (default: 200)
 * @returns Extracted excerpt or undefined if no content available
 */


function extractExcerpt(hit) {
  var _hit$_highlightResult, _hit$_highlightResult2, _hit$_highlightResult3, _hit$_highlightResult4, _hit$_highlightResult5, _hit$_highlightResult6, _hit$_highlightResult7, _hit$_highlightResult8;

  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

  // Try to get highlighted content first (better for showing search matches)
  if ((_hit$_highlightResult = hit._highlightResult) !== null && _hit$_highlightResult !== void 0 && (_hit$_highlightResult2 = _hit$_highlightResult.first_post) !== null && _hit$_highlightResult2 !== void 0 && _hit$_highlightResult2.value) {
    return stripHtmlTags(hit._highlightResult.first_post.value);
  }

  if ((_hit$_highlightResult3 = hit._highlightResult) !== null && _hit$_highlightResult3 !== void 0 && (_hit$_highlightResult4 = _hit$_highlightResult3.content) !== null && _hit$_highlightResult4 !== void 0 && _hit$_highlightResult4.value) {
    return stripHtmlTags(hit._highlightResult.content.value);
  }

  if ((_hit$_highlightResult5 = hit._highlightResult) !== null && _hit$_highlightResult5 !== void 0 && (_hit$_highlightResult6 = _hit$_highlightResult5.answer) !== null && _hit$_highlightResult6 !== void 0 && _hit$_highlightResult6.value) {
    return stripHtmlTags(hit._highlightResult.answer.value);
  }

  if ((_hit$_highlightResult7 = hit._highlightResult) !== null && _hit$_highlightResult7 !== void 0 && (_hit$_highlightResult8 = _hit$_highlightResult7.reply) !== null && _hit$_highlightResult8 !== void 0 && _hit$_highlightResult8.value) {
    return stripHtmlTags(hit._highlightResult.reply.value);
  } // Fallback to raw content


  if (hit.first_post) {
    var text = stripHtmlTags(hit.first_post);
    return text.length > maxLength ? text.substring(0, maxLength) : text;
  }

  if (hit.content) {
    var _text = stripHtmlTags(hit.content);

    return _text.length > maxLength ? _text.substring(0, maxLength) : _text;
  }

  if (hit.answer) {
    var _text2 = stripHtmlTags(hit.answer);

    return _text2.length > maxLength ? _text2.substring(0, maxLength) : _text2;
  }

  return undefined;
}
/**
 * Get the topic ID from a hit
 * Handles different ID field locations (id, objectID, public_id)
 *
 * @param hit - Algolia hit
 * @returns Topic ID as number
 */


function getTopicId(hit) {
  if ('id' in hit && typeof hit.id === 'number') {
    return hit.id;
  }

  if ('public_id' in hit && typeof hit.public_id === 'number') {
    return hit.public_id;
  }

  if ('objectID' in hit) {
    var parsed = parseInt(hit.objectID, 10);

    if (!isNaN(parsed)) {
      return parsed;
    }
  }

  return 0;
}
/**
 * Get the URL from a hit
 * Handles different URL field locations
 *
 * @param hit - Algolia hit
 * @returns URL string
 */


function getHitUrl(hit) {
  return hit.url || hit.topic_url || hit.content_url || '';
}
/**
 * Transform a single Algolia hit to a processed result
 *
 * @param hit - Raw Algolia hit
 * @returns Processed search result
 */


function transformHit(hit) {
  var excerpt = extractExcerpt(hit); // Skip hits without meaningful content

  if (excerpt === undefined || excerpt === '') {
    return null;
  }

  return {
    id: getTopicId(hit),
    title: hit.title || '',
    url: getHitUrl(hit),
    contentType: hit.content_type || '',
    excerpt: excerpt,
    views: hit.views,
    likes: hit.likes,
    votes: hit.votes
  };
}
/**
 * Transform an array of Algolia hits to processed results
 * Filters out hits without valid excerpts
 *
 * @param hits - Array of raw Algolia hits
 * @returns Array of processed search results
 */


function transformHits(hits) {
  return hits.reduce(function (results, hit) {
    var processed = transformHit(hit);

    if (processed) {
      results.push(processed);
    }

    return results;
  }, []);
}
/**
 * Extract topic IDs from hits for metadata fetching
 * Prefers public_id over id for API calls
 *
 * @param hits - Array of Algolia hits
 * @returns Array of topic IDs
 */


function extractTopicIds(hits) {
  return hits.map(function (hit) {
    if ('public_id' in hit && typeof hit.public_id === 'number') {
      return hit.public_id;
    }

    return getTopicId(hit);
  }).filter(function (id) {
    return typeof id === 'number' && !isNaN(id) && id > 0;
  });
}
/**
 * Enriched search result with TopicInfo metadata
 */


/**
 * Merge a processed result with TopicInfo metadata
 *
 * @param result - Processed search result
 * @param metadata - TopicInfo from /search/getTopics
 * @param hit - Optional original hit to fallback for fields like answer
 * @returns Enriched result with metadata
 */
function enrichResultWithMetadata(result, metadata, hit) {
  return _objectSpread(_objectSpread({}, result), {}, {
    privateId: metadata.privateId,
    firstPost: metadata.firstPost,
    relevantPost: metadata.relevantPost,
    lastPost: metadata.lastPost,
    forum: metadata.forum,
    featuredImage: metadata.featuredImage,
    featuredImageAltText: metadata.featuredImageAltText,
    numberOfViews: metadata.numberOfViews,
    numberOfReplies: metadata.numberOfReplies,
    numberOfLikes: metadata.numberOfLikes,
    numberOfUnreadReplies: metadata.numberOfUnreadReplies,
    isTopicUnread: metadata.isTopicUnread,
    hasCurrentUserLiked: metadata.hasCurrentUserLiked,
    hasBestAnswer: metadata.hasBestAnswer,
    // Fallback to hit's answer if metadata doesn't have it
    answer: metadata.answer || (hit === null || hit === void 0 ? void 0 : hit.answer),
    publicLabel: metadata.publicLabel,
    ideationStatus: metadata.ideationStatus,
    bugStatus: metadata.bugStatus,
    isSticky: metadata.isSticky,
    closed: metadata.closed
  });
}
/**
 * Transform hits and merge with metadata map
 * This is the main function for processing Algolia hits with backend enrichment.
 * Used by SDK and Search components for consistent behavior.
 *
 * @param hits - Array of Algolia hits
 * @param metadataMap - Map of topic ID to TopicInfo (from /search/getTopics)
 * @returns Array of enriched search results
 *
 * @example
 * const metadataMap = await fetchTopicsMetadata(extractTopicIds(hits))
 * const results = mergeHitsWithMetadata(hits, metadataMap)
 */


function mergeHitsWithMetadata(hits, metadataMap) {
  return hits.reduce(function (results, hit) {
    var processed = transformHit(hit);

    if (processed) {
      var topicId = getTopicId(hit);
      var metadata = metadataMap.get(topicId);

      if (metadata) {
        // Enrich with metadata, passing hit for fallback values
        results.push(enrichResultWithMetadata(processed, metadata, hit));
      } else {
        // No metadata available, return basic result
        results.push(processed);
      }
    }

    return results;
  }, []);
}
/**
 * @deprecated Use mergeHitsWithMetadata instead
 * Transform hits and merge with metadata map
 */


function transformHitsWithMetadata(hits, metadataMap) {
  return mergeHitsWithMetadata(hits, metadataMap);
}
/**
 * Create a lookup map from an array of TopicInfo
 * Useful for quickly finding topic metadata by ID
 *
 * @param topics - Array of TopicInfo from /search/getTopics
 * @returns Map of topic ID to TopicInfo
 *
 * @example
 * const topics = await fetchTopicsMetadata(ids)
 * const topicMap = createTopicInfoMap(topics)
 * const topic = topicMap.get(123)
 */


function createTopicInfoMap(topics) {
  var map = new Map();

  var _iterator = _createForOfIteratorHelper(topics),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var topic = _step.value;
      map.set(topic.id, topic);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return map;
}
/**
 * Create a lookup object (record) from an array of TopicInfo
 * Alternative to createTopicInfoMap for components that prefer plain objects
 *
 * @param topics - Array of TopicInfo from /search/getTopics
 * @returns Record of topic ID to TopicInfo
 *
 * @example
 * const topics = await fetchTopicsMetadata(ids)
 * const topicRecord = createTopicInfoRecord(topics)
 * const topic = topicRecord[123]
 */


function createTopicInfoRecord(topics) {
  return topics.reduce(function (acc, topic) {
    acc[topic.id] = topic;
    return acc;
  }, {});
}
/**
 * Merge answer from hit into TopicInfo (answer fallback pattern)
 * Used when TopicInfo from /search/getTopics doesn't have answer but hit does
 *
 * @param topicInfo - TopicInfo from backend
 * @param hit - Original Algolia hit
 * @returns TopicInfo with answer from hit if missing
 */


function mergeAnswerFromHit(topicInfo, hit) {
  if (!topicInfo.answer && 'answer' in hit && hit.answer) {
    return _objectSpread(_objectSpread({}, topicInfo), {}, {
      answer: hit.answer,
      has_answer: 'has_answer' in hit ? hit.has_answer : topicInfo.has_answer
    });
  }

  return topicInfo;
}